import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export var chipConfig = {
  skins: {
    lighten: {
      black: {
        fill: {
          bg: function bg(_ref) {
            var theme = _ref.theme;
            return theme.colors.tertiary.ultraLighten;
          },
          textColor: function textColor(_ref2) {
            var theme = _ref2.theme;
            return theme.colors.grey72;
          },
          border: function border(_ref3) {
            var theme = _ref3.theme;
            return theme.colors.tertiary.ultraLighten;
          }
        },
        outline: {
          border: function border(_ref4) {
            var theme = _ref4.theme;
            return theme.colors.tertiary.darken;
          },
          bg: function bg(_ref5) {
            var theme = _ref5.theme;
            return theme.colors.tertiary.ultraLighten;
          },
          textColor: function textColor(_ref6) {
            var theme = _ref6.theme;
            return theme.colors.grey72;
          }
        }
      },
      extra: {
        fill: {
          bg: function bg(_ref7) {
            var theme = _ref7.theme;
            return theme.colors.extra.ultraLighten;
          },
          textColor: function textColor(_ref8) {
            var theme = _ref8.theme;
            return theme.colors.extra.normal;
          },
          border: function border(_ref9) {
            var theme = _ref9.theme;
            return theme.colors.extra.ultraLighten;
          }
        },
        outline: {
          border: function border(_ref10) {
            var theme = _ref10.theme;
            return theme.colors.extra.normal;
          },
          bg: function bg(_ref11) {
            var theme = _ref11.theme;
            return theme.colors.extra.ultraLighten;
          },
          textColor: function textColor(_ref12) {
            var theme = _ref12.theme;
            return theme.colors.extra.normal;
          }
        }
      },
      secondary: {
        fill: {
          bg: function bg(_ref13) {
            var theme = _ref13.theme;
            return theme.colors.secondary.ultraLighten;
          },
          textColor: function textColor(_ref14) {
            var theme = _ref14.theme;
            return theme.colors.secondary.normal;
          },
          border: function border(_ref15) {
            var theme = _ref15.theme;
            return theme.colors.secondary.ultraLighten;
          }
        },
        outline: {
          border: function border(_ref16) {
            var theme = _ref16.theme;
            return theme.colors.secondary.normal;
          },
          bg: function bg(_ref17) {
            var theme = _ref17.theme;
            return theme.colors.secondary.ultraLighten;
          },
          textColor: function textColor(_ref18) {
            var theme = _ref18.theme;
            return theme.colors.secondary.normal;
          }
        }
      }
    },
    darken: {
      black: {
        fill: {
          bg: function bg(_ref19) {
            var theme = _ref19.theme;
            return theme.colors.grey72;
          },
          border: function border(_ref20) {
            var theme = _ref20.theme;
            return theme.colors.grey72;
          }
        },
        outline: {
          border: function border(_ref21) {
            var theme = _ref21.theme;
            return theme.colors.grey72;
          },
          textColor: function textColor(_ref22) {
            var theme = _ref22.theme;
            return theme.colors.grey72;
          }
        }
      },
      extra: {
        fill: {
          bg: function bg(_ref23) {
            var theme = _ref23.theme;
            return theme.colors.extra.normal;
          },
          border: function border(_ref24) {
            var theme = _ref24.theme;
            return theme.colors.extra.normal;
          }
        },
        outline: {
          border: function border(_ref25) {
            var theme = _ref25.theme;
            return theme.colors.extra.normal;
          },
          textColor: function textColor(_ref26) {
            var theme = _ref26.theme;
            return theme.colors.extra.normal;
          }
        }
      },
      secondary: {
        fill: {
          bg: function bg(_ref27) {
            var theme = _ref27.theme;
            return theme.colors.secondary.normal;
          },
          border: function border(_ref28) {
            var theme = _ref28.theme;
            return theme.colors.secondary.normal;
          }
        },
        outline: {
          border: function border(_ref29) {
            var theme = _ref29.theme;
            return theme.colors.secondary.normal;
          },
          textColor: function textColor(_ref30) {
            var theme = _ref30.theme;
            return theme.colors.secondary.normal;
          }
        }
      }
    }
  },
  padding: {
    small: '4px',
    medium: '6px',
    large: '8px'
  }
};
export var IconColorHook = function IconColorHook(_ref31) {
  var variant = _ref31.variant,
      color = _ref31.color,
      skin = _ref31.skin;

  var _useContext = useContext(ThemeContext),
      colors = _useContext.colors;

  var chipIconConfig = {
    skins: {
      lighten: {
        black: {
          fill: {
            iconColor: colors.grey72
          },
          outline: {
            iconColor: colors.grey72
          }
        },
        extra: {
          fill: {
            iconColor: colors.extra.normal
          },
          outline: {
            iconColor: colors.extra.normal
          }
        },
        secondary: {
          fill: {
            iconColor: colors.secondary.normal
          },
          outline: {
            iconColor: colors.secondary.normal
          }
        }
      },
      darken: {
        black: {
          outline: {
            iconColor: colors.grey72
          }
        },
        extra: {
          outline: {
            iconColor: colors.extra.normal
          }
        },
        secondary: {
          outline: {
            iconColor: colors.secondary.normal
          }
        }
      }
    }
  };
  return chipIconConfig.skins[variant][color][skin].iconColor;
};